import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { compose } from 'ramda';

import connect from 'app/libs/connect';
import {
  metaTitle,
  metaDescription,
  metaKeywords,
} from 'app/features/landing/meta/selectors';
import { getAppName } from 'app/router/selectors';
import { domain } from 'config/selectors';
import withLocale from 'app/features/localization/enhancers/withLocale';
import localizeLink from 'app/features/localization/localizeLink';
import { routerLocales, etpLocales } from 'app/router/constants/routerLocales';

const UI = ({ metaTitle, metaDescription, metaKeywords, appName, locale }) => {
  const localizedUrl = localizeLink(`https://${domain}/${appName}`, locale);

  const hreflangLinks = Object.keys(routerLocales).map(localeKey => {
    const hreflangUrl = localizeLink(`https://${domain}/${appName}`, localeKey);
    const hreflangCode = etpLocales[localeKey] || localeKey;

    return (
      <link
        key={localeKey}
        rel="alternate"
        hrefLang={hreflangCode}
        href={hreflangUrl}
      />
    );
  });

  return (
    <Helmet title={metaTitle}>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:locale" content={locale} />
      <meta property="og:url" content={localizedUrl} />
      <link
        rel="canonical"
        href={localizedUrl || 'https://www.crunchyroll.com/welcome'}
      />
      {hreflangLinks}
    </Helmet>
  );
};

UI.propTypes = {
  appName: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  metaTitle: PropTypes.string.isRequired,
  metaDescription: PropTypes.string.isRequired,
  metaKeywords: PropTypes.string.isRequired,
};

UI.displayName = 'Meta';

const state = { metaTitle, metaDescription, metaKeywords, appName: getAppName };

const Meta = compose(connect(state), withLocale)(UI);

export { UI };

export default Meta;
